import React, { useEffect, useState } from 'react';
import './Gallery.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Topbar from './Topbar';
import PROFILEPNG from '../images/PROFILEPNG.webp'
import GOOGLEMEETICONS from '../images/GOOGLEMEETICONS.webp'
import './Googlemeet.css';
export default function Googlemeet() {



 useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };

  return (
    <>
     
        <div><Navbar /></div>
    <div id="shiva-nadi-page">
    {/* Header Section */}
    <section id="header-section">
      <div className="container text-center">
        <h1 className="animated-title">Shiva Nadi Astrology</h1>
        <p>Discover divine guidance through our Google Meeting services.</p>
      </div>
    </section>





 {/* <!-- How We Use This Page Section --> */}
 <section id="HowBookuse">
  <div class="container">
    <h2>How We Follow Our Client</h2>
    <center>
                      <img src={GOOGLEMEETICONS} alt='whatsapp icons' title='whatsapp icons' id='whats'/>
                              <h5>Connect With Google Meet</h5>
                              </center>
    <div class="steps">
      <div class="step">
        <div class="icon">
          <img src="https://via.placeholder.com/50?text=1" alt="Step 1" />
        </div>
        <div class="content">
          <h3>Step 1: Book Your Meeting</h3>
            
          <p>Fill out the booking form to schedule your Google Meet session. Choose your preferred date and time.</p>
        </div>
      </div>
      <div class="step">
        <div class="icon">
          <img src="https://via.placeholder.com/50?text=2" alt="Step 2" />
        </div>
        <div class="content">
          <h3>Step 2: Receive Confirmation</h3>
          <p>Once we receive your booking form, we will confirm the meeting via email, phone, or WhatsApp.</p>
        </div>
      </div>
      <div class="step">
        <div class="icon">
          <img src="https://via.placeholder.com/50?text=3" alt="Step 3" />
        </div>
        <div class="content">
          <h3>Step 3: Get in Touch</h3>
          <p>Our team will contact you using your preferred method (phone, WhatsApp, or email) to finalize the details.</p>
        </div>
      </div>
    </div>
  </div>
</section>






    {/* Book Meeting Section */}
    <section id="book-meeting-section">
      <div className="container">
        <h2>Book a Google Meeting</h2>
        <form action="https://api.web3forms.com/submit" className="booking-form" method="POST">

    
    <input type="hidden" name="access_key" value="85e98817-d859-4713-9203-f6b97022ee6f"/>

        
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <input type="datetime-local" name="datetime-local" required />
          <button type="submit" className="btn-schedule">Schedule Meeting</button>
        </form>
      </div>
    </section>


    {/* <!-- Ask Any Question Section --> */}
<section id="ASKANYQUES">
  <div class="container">
    <h2>Have Any Questions About Shiva Nadi Astrology?</h2>
    <p>If you have any questions about the Shiva Nadi Astrology session or anything related to our services, feel free to reach out to us. We're happy to assist you!</p>
    <div class="contact-options">
      <div class="option">
        <div class="content">
          <h3>Contact Us by Phone or WhatsApp</h3>
          <p>For faster assistance, you can contact us directly via phone or WhatsApp at <a href="https://wa.me/7402167580">+91 7402167580</a>. We are available to help you with any inquiries or concerns you may have.</p>
        </div>
      </div>
      <div class="option">
        <div class="content">
          <h3>Contact Us via Email</h3>
          <p>If you prefer to contact us via email, feel free to send us your questions at <a href="mailto:shivanadiastrologer@gmail.com">shivanadiastrologer@gmail.com</a>. We will get back to you as soon as possible.</p>
        </div>
      </div>
    </div>
    <p>If you're experiencing any issues, we’ll promptly contact you via email or WhatsApp to resolve your concern.</p>
  </div>
</section>




    {/* Ask Questions Section */}
    <section id="ask-questions-section">
    <div className="container">
  <h2>Ask Your Questions</h2>
  <form action="https://api.web3forms.com/submit" className="question-form" method="POST">
  
  <input type="hidden" name="access_key" value="85e98817-d859-4713-9203-f6b97022ee6f"/>
  <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <input type="tel" id="phone" name="phone" placeholder="Enter your phone number" required />
    <textarea 
      name="question" 
      placeholder="Write your question here..." 
      rows="4" 
      required
    ></textarea>
    <center>
      <button type="submit" className="btn-submit">Submit Question</button>
    </center>
  </form>
</div>

    </section>

    
<section id="reviews-section">
  <div class="container">
    <h2>What Our Clients Say</h2>
    <div class="review-cards">
      <div class="review-card">
        <img src={PROFILEPNG} alt="Client 1" class="client-img" />
        <p><strong>Client 1</strong>: "The Shiva Nadi Astrology Google Meet session was mind-blowing! Everything was so accurate!"</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 2" class="client-img" />
        <p><strong>Client 2</strong>: "I was amazed by the insights I received. Highly recommend the session!"</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 3" class="client-img" />
        <p><strong>Client 3</strong>: "A transformative experience! The astrologer’s predictions were spot on."</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 4" class="client-img" />
        <p><strong>Client 4</strong>: "I learned so much about my past, present, and future during the session. Truly enlightening!"</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 5" class="client-img" />
        <p><strong>Client 5</strong>: "The Google Meet session was very comfortable, and I felt completely connected. Highly recommend!"</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 6" class="client-img" />
        <p><strong>Client 6</strong>: "The session was beyond expectations. Everything was accurate, and I feel more at peace."</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 7" class="client-img" />
        <p><strong>Client 7</strong>: "An eye-opening experience! The astrology reading was truly amazing!"</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 8" class="client-img" />
        <p><strong>Client 8</strong>: "Highly accurate and deeply spiritual. The session gave me a new perspective on life!"</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 9" class="client-img" />
        <p><strong>Client 9</strong>: "Amazing! I never thought astrology could be so precise. This session was truly enlightening!"</p>
      </div>
      <div class="review-card">
        <img src={PROFILEPNG}  alt="Client 10" class="client-img" />
        <p><strong>Client 10</strong>: "I’m amazed at how everything was so accurate. The session was an unforgettable experience!"</p>
      </div>
    </div>
  </div>
</section>


    {/* Extra Content Section */}
    <section id="extra-content-section">
      <div className="container text-center">
        <h2 style={{ color: "white" }}>Why Choose Shiva Nadi Astrology?</h2>

        <ul className="features-list">
          <li>Personalized guidance from ancient wisdom.</li>
          <li>Seamless online consultations via Google Meet.</li>
          <li>Trusted by thousands of satisfied clients worldwide.</li>
          <li>Flexible scheduling options to suit your needs.</li>
        </ul>
      </div>
    </section>


    {/* <section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE, Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad, Telangana 500062</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +91 74021 67580<br/>Email:shivanadiastrologer@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
      <a href="https://www.google.com/maps?q=LIG-+B,+Plot+No:+204,+Dr.+AS+Rao+Nagar+Rd,+beside+SUB+POST+OFFICE,+Anupuram+Colony,+A.+S.+Rao+Nagar,+Hyderabad,+Secunderabad,+Telangana+500062" target="_blank">View on Google Maps</a>

      </p>
    </div>
  </div>
</section> */}
  </div>
  {/* <div><Footer /></div> */}
  </>
  )
}
